import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  RDS_DIALOG_DATA,
  RdsButtonModule,
  RdsDialogModule,
  RdsDialogRef,
  RdsFormFieldModule,
  RdsIconsModule,
} from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../../constants/buttons.constants';
import { ERRORS_TEXTS } from '../../../../constants/errors.contstants';
import { RichTextEditorComponent } from '../../../shared/rich-text-editor/rich-text-editor.component';
import { POPUPS } from '../../../../constants/popups.constants';

@Component({
  selector: 'inexp-focus-user-instruction-dialog',
  imports: [
    ReactiveFormsModule,
    RdsDialogModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsFormFieldModule,
    RichTextEditorComponent,
  ],
  templateUrl: './focus-user-instruction-dialog.component.html',
  styleUrl: './focus-user-instruction-dialog.component.scss',
})
export class FocusUserInstructionDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _dialogRef =
    inject<RdsDialogRef<FocusUserInstructionDialogComponent>>(RdsDialogRef);
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    userInstructions?: { title: string; description: string };
  };
  readonly ERRORS = ERRORS_TEXTS;
  readonly BUTTONS = BUTTON_TEXTS;
  readonly POPUPS = POPUPS;
  form = this._fb.group({
    title: [this.data.userInstructions?.title ?? '', Validators.required],
    description: [
      this.data.userInstructions?.description ?? '',
      [Validators.required],
    ],
  });

  submit() {
    if (this.form.valid) {
      this._dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
